import { render, staticRenderFns } from "./breakingNews.vue?vue&type=template&id=1d08a864&scoped=true"
import script from "./breakingNews.vue?vue&type=script&lang=js"
export * from "./breakingNews.vue?vue&type=script&lang=js"
import style0 from "./breakingNews.vue?vue&type=style&index=0&id=1d08a864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08a864",
  null
  
)

export default component.exports